/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvoucherredeemed2Inputs */

const en_dropvoucherredeemed2 = /** @type {(inputs: Dropvoucherredeemed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeemed`)
};

const de_dropvoucherredeemed2 = /** @type {(inputs: Dropvoucherredeemed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingelöst`)
};

/**
* | output |
* | --- |
* | "Redeemed" |
*
* @param {Dropvoucherredeemed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvoucherredeemed2 = /** @type {((inputs?: Dropvoucherredeemed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvoucherredeemed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvoucherredeemed2(inputs)
	return de_dropvoucherredeemed2(inputs)
});
export { dropvoucherredeemed2 as "dropVoucherRedeemed" }